export const setBotQueryPagination = (state, action) => {
  state.botQuery.pagination = action.payload
}
